import * as React from 'react';

import { OutputMapperEditorPanel } from '../../../customer/components/OutputMapper/index.ts';
import { ORDER_OUTPUT_MAPPER_KEY } from '../constants.ts';

interface Props {
    channelId?: string;
}

/**
 * Output mapper for the order processing channel (registry owner `order`). Drives the shared editor
 * panel (read / save / refresh / test) via the generic API; the notice states when the mapping goes live.
 */
const OrderOutputMapperPanel = ({ channelId }: Props): React.ReactElement => {
    return (
        <div className="flex h-full min-h-0 flex-col">
            <OutputMapperEditorPanel outputMapperKey={ORDER_OUTPUT_MAPPER_KEY} ownerId={channelId} recordType="order" />
        </div>
    );
};

export default OrderOutputMapperPanel;
